export const usersFieldLabels = {
  externalId: {
    id: 'Patient.Appointment.Create.CustomerID.Label',
    defaultMessage: '** Customer ID',
  },
  phoneNumber: {
    id: 'Patient.Appointment.Create.PhoneNumber.Label',
    defaultMessage: '** Mobile Phone',
  },
  email: {
    id: 'Patient.Appointment.Create.Email.Label',
    defaultMessage: '** Email',
  },
  lastName: {
    id: 'Patient.Appointment.Create.LastName.Label',
    defaultMessage: '** Family Name',
  },
  firstName: {
    id: 'Patient.Appointment.Create.GivenName.Label',
    defaultMessage: '** Given Name',
  },
  dateOfBirth: {
    id: 'MyAccount.Details.Edit.DateOfBirth',
    defaultMessage: '** Date of Birth',
  },
  gender: {
    id: 'Patient.Appointment.Create.Gender.Label',
    defaultMessage: '** Gender',
  },
  patientId: {
    id: 'AdminConsole.Appointments.Create.Dialog.PatientID.Title',
    defaultMessage: '** Patient ID',
  },
};

export const appointmentFormFieldLabels = {
  contractId: {
    id: 'Patient.Appointment.Create.Service.Label',
    defaultMessage: '** Service',
  },
  conversationType: {
    id: 'Patient.Appointment.Create.ConversationType.Label',
    defaultMessage: '** Conversation Type',
  },
  date: {
    id: 'Patient.Appointment.Create.ApptDate.Label',
    defaultMessage: '** Appt Date',
  },
  startDate: {
    id: 'Patient.Appointment.Create.StartDate.Label',
    defaultMessage: '** Start Date',
  },
  endDate: {
    id: 'Patient.Appointment.Create.EndDate.Label',
    defaultMessage: '** End Date',
  },
  timeSlot: {
    id: 'Patient.Appointment.Create.TimeSlot.Label',
    defaultMessage: '** Time slot',
  },
  createdBy: {
    id: 'Reports.CreatedBy',
    defaultMessage: '** Created by',
  },
  providerUserId: {
    id: 'Patient.Appointment.Create.Provider.Label',
    defaultMessage: '** Provider',
  },
  state: {
    id: 'AdminConsole.AppointmentsList.Header.ApptStatusReason',
    defaultMessage: '** Appt Close Reason',
  },
  status: {
    id: 'Operations.AppointmentsList.Header.ApptStatus',
    defaultMessage: '** Appt. status',
  },
  cancelReason: {
    id: 'AdminConsole.Appointments.DetailedView.AppointmentDetails.EditDialog.CancelationReason',
    defaultMessage: '** Cancellation reason',
  },
  flexibleFrom: {
    id: 'Patient.Appointment.Create.StartTime.Label',
    defaultMessage: '** Start Time',
  },
  flexibleTo: {
    id: 'Patient.Appointment.Create.EndTime.Label',
    defaultMessage: '** End Time',
  },
  consultationType: {
    id: 'NewConsultationWizard.ConsultationTypeSelection.Title',
    defaultMessage: '** Select consultation type',
  },
  ...usersFieldLabels,
};
